export default "__VITE_ASSET__bn8xYop1__"